import InvestmentDocusignEvents from "./InvestmentDocusignEvents"

export default InvestmentDocusignEvents
